import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GetUser } from "store/slices/authSlice";
import { MailChimpSubscriptionApi } from "store/slices/salonSlice";
import { usermoduleListViewApi } from "../store/slices/usermoduleSlice";
import { OpenAddClientForm } from "../store/slices/clientSlice";
import { notificationCountApi } from "store/slices/notificationSlice";

// Module-level guards so remounting pages/drawers that call SalonModule()
// do not re-fire global bootstrap APIs on every open.
let authUserFetched = false;
let notificationCountFetched = false;
let mailchimpFetchedForSalon = null;

const SalonModule = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const usermodule = useSelector((state) => state.usermodule.isListView);
  const auth = useSelector((state) => state.auth);
  const currentUser = auth && auth.user;
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth?.user?.auth_key || !auth?.token) return;
    if (authUserFetched) return;
    authUserFetched = true;
    dispatch(GetUser()).unwrap().catch(() => {
      authUserFetched = false;
    });
  }, [dispatch, auth?.user?.auth_key, auth?.token]);

  if (currentUser && currentUser.role_id == 8 && ["/dashboard", "/staff", "/reports"].includes(location && location.pathname)) {
    navigate("/noaccess");
  }

  useEffect(() => {
    if (usermodule.length === 0) {
      dispatch(usermoduleListViewApi());
      dispatch(usermoduleListViewApi({ type: "staff_access" }));
    }
    if (!notificationCountFetched) {
      notificationCountFetched = true;
      dispatch(notificationCountApi());
    }
  }, [dispatch, location.pathname, usermodule.length]);

  useEffect(() => {
    dispatch(OpenAddClientForm(""));
    const salonId = currentUser && currentUser.salon && currentUser.salon.id ? currentUser.salon.id : "";
    if (salonId && mailchimpFetchedForSalon !== salonId) {
      mailchimpFetchedForSalon = salonId;
      dispatch(MailChimpSubscriptionApi({ id: salonId, salon_id: salonId }));
    }
  }, [dispatch, location.pathname, currentUser && currentUser.salon && currentUser.salon.id]);

};

export { SalonModule };
